module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f073d4_banner_800x600.5fe3fdc4.png";